<template>
  <div>
    <div
      :class="{
        columns: withColumns,
        'columns-width-resv-book-local': withColumns,
        'datepicker-disabled': disabled,
      }"
      :style="`width: ${forcedWidth};'`">
      <div
        :class="{
          column: withColumns,
          'col-2': withColumns,
          'col-md-12': withColumns,
          'col-less-padding': withColumns,
        }"
        class="label-class-resv-book-local"
        v-if="label && (showDate || showTime)">
        {{ label }}
      </div>
      <template v-if="!mobileView">
        <!-- Date picker -->
        <div
          :class="{
            column: withColumns,
            'col-5': withColumns,
            'col-sm-12': withColumns,
            'col-less-padding-resv-book-local': withColumns,
          }"
          v-show="showDate && (!showDateAsToggle || dateToggle || disabled)">
          <label
            style="float: left;"
            :for="dpid" :aria-label="ariaLabel" v-if="!dayModeOffset">
          </label>
          <label
            style="float: left;"
            :for="`${dpid}-day`" :aria-label="ariaLabel"
            v-if="dayModeOffset">
          </label>
          <div class="date-picker-preview" v-show="!dayModeOffset">
            <date-picker
              v-model:model-value="dateValueDownstream"
              :disabledDates="{
                predicate: disabledDate,
              }"
              :disabled="disabled"
              :id="dpid"
              :label="label"
              :parentEleId="parentEleId"
              :uniqueId="datePickerUniqueId"
              :weekStartsOn="lodash.get(datePickerOptionsLocal,
                'firstDayOfWeek')"
              type="date"
              @click.stop="FocusDatePicker"
              @closed="handleDatePick({})"
              :ref="datePickerRefName">
            </date-picker>
          </div>
          <div class="date-picker-preview" v-show="dayModeOffset">
            <date-picker
              v-model:model-value="dateValueDownstream"
              :disabledDates="{
                predicate: disabledDate,
              }"
              :disabled="disabled"
              :id="`daymode-${dpid}`"
              :label="label"
              :model-value="dateMinusOne"
              :parentEleId="parentEleId"
              :uniqueId="datePickerDayModeUniqueId"
              :weekStartsOn="lodash.get(datePickerOptionsLocal,
                'firstDayOfWeek')"
              type="date"
              @click.stop="FocusDatePicker"
              @closed="handleDatePick({})"
              :ref="datePickerDayModeRefName">
            </date-picker>
          </div>
        </div>
        <div
          v-if="showDate && showDateAsToggle && !dateToggle && !disabled"
          :class="{
            column: withColumns,
            'col-5': withColumns,
            'col-sm-12': withColumns,
            'col-less-padding-resv-book-local': withColumns,
          }"
          style="text-align: left;">
          <button
            class="btn btn-link inline"
            data-id="date-toggle"
            @click="dateToggle = true"
            style="padding: 0;">
            {{ dateToggleString }}
          </button>
        </div>

        <!-- Time picker -->
        <div
          v-if="clockPicker && showTime"
          :class="{
            column: withColumns,
            'col-5': withColumns,
            'col-sm-12': withColumns,
            'col-less-padding-resv-book-local': withColumns,
          }">
          <label :for="`${dpid}-clock`" :aria-label="ariaLabel"></label>
          <clock-picker
            :dispenseGlobalProp="dispenser"
            :defaultHour="defaultHour"
            :defaultMinute="defaultMinute"
            :disabled="disabled"
            :id="`${dpid}-clock`"
            :minuteIntervalRestriction="minuteIntervalRestriction"
            :minuteIntervalRestrictionDisplay="minuteIntervalRestrictionDisplay"
            :mode="12"
            :parentHour="hourDownstream"
            :parentMinute="minuteDownstream"
            :uniqueId="clockPickerUniqueId"
            @emitTimeObj="handleTimeObj">
          </clock-picker>
        </div>
        <div
          v-show="!clockPicker && showTime"
          :class="{
            column: withColumns,
            'col-5': withColumns,
            'col-sm-12': withColumns,
            'col-less-padding-resv-book-local': withColumns,
          }">
          <label
            :for="`${timePickerIdSafe}-day-mode`"
            :aria-label="ariaLabel"></label>
          <time-picker
            :dispenseGlobalProp="dispenser"
            :defaultHour="defaultHour"
            :defaultMinute="defaultMinute"
            :defaultTimes="defaultTimes"
            :disabled="disabled"
            :disabledTime="disabledTime"
            :minuteIntervalRestriction="minuteIntervalRestriction"
            :minuteIntervalRestrictionDisplay="minuteIntervalRestrictionDisplay"
            :mode="timePickerModeComputed"
            :parentEleId="parentEleId"
            :inputId="`${timePickerIdSafe}-day-mode`"
            :nextTimePickerFocusId="nextTimePickerFocusId"
            :uniqueId="timePickerUniqueId"
            @emitTimeObj="handleTimeObj">
          </time-picker>
        </div>
      </template>
      <template v-else>
        <div
          v-show="showTime"
          :id="`${uniqueId}-timepicker-display`"
          class="time-picker-container"
          style="width: 235px;">
          <div
            class="time-picker-preview"
            style="width: 100%;"
            :class="{
              disabled: disabled,
            }">
            <span class="clock">
              <font-awesome-icon :icon="faIcons.faCalendarDay" />
            </span>
            <!-- iOS detects on @blur, while Android detects on @change -->
            <input
              :aria-label="ariaLabel"
              :ref="mobileInputDateTimeRefName"
              type="datetime-local"
              required="required"
              :disabled="disabled || null"
              style="width: 100%;"
              v-model="mobilePickerValue"
              @focus="mobilePickerValueCached = mobilePickerValue"
              @blur="() => generateMomentDate(true)"
              @change="() => generateMomentDate(false)">
          </div>
        </div>
        <div
          v-show="!showTime"
          :id="`${uniqueId}-date-picker-display`"
          class="time-picker-container"
          style="width: 235px;">
          <div
            class="time-picker-preview"
            style="width: 100%;"
            :class="{
              disabled: disabled,
            }">
            <span class="clock">
              <font-awesome-icon :icon="faIcons.faCalendarDay" />
            </span>
            <!-- iOS detects on @blur, while Android detects on @change -->
            <input
              :aria-label="ariaLabel"
              :ref="mobileInputDateRefName"
              type="date"
              required="required"
              :disabled="disabled || null"
              style="width: 100%;"
              :value="mobilePickerValue"
              @focus="mobilePickerValueCached = mobilePickerValue"
              @blur="(evt) => handleDatePick({ event: evt, isBlur: true })"
              @change="(evt) => handleDatePick({ event: evt, isBlur: false })">
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
/* eslint-disable vue/one-component-per-file */
import _ from 'lodash';
import mobile from 'is-mobile';
import moment from 'moment';

import { Mutex } from 'async-mutex';

import { DateTypeCheck } from 'assets/js/time';
import { SpawnDispenser } from 'assets/js/dispense';
import { uuid4 } from 'assets/js/util';

import ClockPicker from 'components/Widgets/ClockPicker/TimePicker';
import DatePicker from 'components/Widgets/DatePicker/DatePicker';
import TimePicker from 'components/Widgets/TimePicker/TimePicker';

// nativeDatePickerFormat is the moment format for the native date picker.
const nativeDatePickerFormat = 'YYYY-MM-DD';

// nativePickerFormat is the moment format for the native datetime picker.
const nativePickerFormat = 'YYYY-MM-DDTHH:mm';

export default {
  name: 'date-time-picker',
  components: {
    'clock-picker': ClockPicker,
    'date-picker': DatePicker,
    'time-picker': TimePicker,
  },
  // compatConfig: { COMPONENT_V_MODEL: false },

  beforeUnmount() {
    if (this.dispenseGlobalProp && this.uniqueIdLocal) {
      this.dispenseGlobalProp.unsubscribe(this.uniqueIdLocal);
    }

    if (this.dispenser) {
      this.dispenser.teardown();
    }
  },

  computed: {
    ariaLabel() {
      if (this.label) return this.label;
      if (this.showDate && this.showTime) return 'Date and time selector';
      if (!this.showTime) return 'Date selector';
      if (!this.showDate) return 'Time selector';
      return 'Date time selector';
    },

    datePickerRefName() {
      return `${this.uniqueId}-dp`;
    },

    datePickerDayModeRefName() {
      return `${this.uniqueId}-dp-dm`;
    },

    // dpid is the date picker ID.
    dpid() {
      return `${this.uniqueId}-date-picker`;
    },

    // dateMinusOne represents the previous date by a single day. Used to tweak
    // the date picker for day-only mode.
    dateMinusOne() {
      if (!this.dateValue) return new Date();
      if (_.isString(this.dateValue)) {
        const dv = moment(this.dateValue);
        return dv.add(-1, 'days').toDate();
      }
      if (!_.isFunction(_.get(this, 'dateValue.toISOString'))) return '';
      return moment(this.dateValue.toISOString()).add(-1, 'days').toDate();
    },

    datePickerOptionsLocal() {
      let localOptions = _.cloneDeep(this.datePickerOptions);
      if (!localOptions) localOptions = {};

      if (!_.isNumber(localOptions.firstDayOfWeek)) {
        const firstDayOfWeek = moment().localeData().firstDayOfWeek();
        localOptions.firstDayOfWeek = firstDayOfWeek;
      }

      return localOptions;
    },

    forcedWidth() {
      if (!this.mobileView) {
        if (typeof this.width === 'number') {
          return `${this.width}px`;
        }
        return this.width;
      }
      return 'auto';
    },

    mobileInputDateRefName() {
      return `${this.uniqueId}-date-input-text-box`;
    },

    mobileInputDateTimeRefName() {
      return `${this.uniqueId}-date-time-input-text-box`;
    },

    // timePickerModeComputed takes a site configuration for a time picker
    // mode and translates it into the expected values for the 'mode' in
    // the timepicker component.
    timePickerModeComputed() {
      if (this.timePickerMode === 'ampm') return '12h';
      if (this.timePickerMode === '24h') return '24h';
      return undefined;
    },

    // To avoid undefined IDs, this computed will check if timePickerId is
    // undefiend and set its own UUID in its place. When it is undefined the
    // actual ID typically doesn't matter so this just avoids duplicates.
    timePickerIdSafe() {
      if (!this.timePickerId) return this.uuid4();
      else return this.timePickerId;
    },
  },

  created() {
    this.mobileView = mobile({ tablet: true });

    this.datePickerUniqueId = `date-picker-child-${this.uuid4()}`;
    this.datePickerDayModeUniqueId = `date-picker-dm-child-${this.uuid4()}`;
    if (this.clockPicker) {
      this.clockPickerUniqueId = `clock-picker-child-${this.uuid4()}`;
    } else {
      this.timePickerUniqueId = `time-picker-child-${this.uuid4()}`;
    }

    this.dispenser = SpawnDispenser(this.name);
    if (this.dispenseGlobalProp) {
      this.uniqueIdLocal = this.name;
      if (this.uniqueId) this.uniqueIdLocal = this.uniqueId;
      this.dispenseGlobalProp.subscribe(this.uniqueIdLocal, async (val) => {
        switch (val.name) {
          case 'dateset': {
            await this.DateSet(val.value);
            break;
          }
          default: {
            throw Error('unknown message from parent component: ' +
                `${JSON.stringify(val)}`);
          }
        }
      });
    }
  },

  data() {
    const DATE_VALUE_FORMAT = 'YYYY-MM-DD';
    return {
      DATE_VALUE_FORMAT,

      clockPickerUniqueId: '',
      datePickerUniqueId: '',
      datePickerDayModeUniqueId: '',
      dateSetterMutex: new Mutex(),
      dateValue: '',
      dateValueDownstream: new Date(),
      dateToggle: false,
      dispenser: null,
      fpOptions: {},
      hourDownstream: null,
      minuteDownstream: null,
      mobileView: false,
      mobilePickerValue: null,
      mobilePickerValueCached: null,
      name: 'date-time-picker',
      timePickerUniqueId: '',
      timeValue: {},
      uniqueIdLocal: '',
    };
  },

  emits: [
    'dateObject',
    'emitError',
  ],

  methods: {
    // ***********************************************************************
    // Internal
    // ***********************************************************************
    // generateMomentDate returns an object containing a moment date and
    // a date string that can be used directly by QReserve's reservation
    // system. It emits this object to the parent.
    // If this function is called from a @blur event, isBlur should be true
    // so we can decide to act only on blur on iOS devices.
    async generateMomentDate(isBlur) {
      // Skip the startup null emission.
      if (this.dateValue === '' || !this.dateValue) {
        return;
      }

      // iOS safari, starting in 14 it seems, will send a change event every
      // time you type a value of a time.  For example, if you want 4:30 and
      // you type 43 then you get a time of 12:43 sent BEFORE you are sent
      // 4:30 and this messes everything up.  So, we only handle updates when
      // you close the date-picker and an isBlur event is thrown; otherwise,
      // abort early.
      function iOS() {
        return [
          'iPad Simulator',
          'iPhone Simulator',
          'iPod Simulator',
          'iPad',
          'iPhone',
          'iPod',
        ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
      }
      if (this.mobileView && !isBlur && iOS()) {
        return;
      }

      // Desktop.
      if (!this.mobileView) {
        let dv;
        if (_.get(this, ['dateValue', 'format'])) {
          dv = `${this.dateValue.format('YYYY-MM-DD')}T`;
        } else {
          // We got a date from upstream element calendar, parse it.
          if (_.get(this, ['dateValue', 'toISOString'])) {
            const dateMoment = moment(this.dateValue.toISOString());
            dv = `${dateMoment.format('YYYY-MM-DD')}T`;
          }

          // String in the format YYYY-MM-DD or YYYY/MM/DD.
          if (this.dateValue.length && this.dateValue.length === 10) {
            dv = `${this.dateValue}T`.replace(/\//g, '-');
          }
        }

        const tvh = this.timeValue.hour < 10 ?
          `0${this.timeValue.hour}` : String(this.timeValue.hour);
        const tvm = this.timeValue.minute < 10 ?
          `0${this.timeValue.minute}` : String(this.timeValue.minute);
        const dateAndTimeLocal = moment(`${dv}${tvh}:${tvm}`);

        this.$emit('dateObject', DateTypeCheck({
          dateMoment: dateAndTimeLocal,
          dateString:
              dateAndTimeLocal.format().substring(0, 19),
        }));
      } else {
        // Mobile. Do nothing if the clear button was pressed.
        if (!this.mobilePickerValue) {
          this.mobilePickerValue = this.mobilePickerValueCached;
          return;
        }
        this.mobilePickerValueCached = this.mobilePickerValue;
        let dateAndTimeLocal;
        if (this.showTime) {
          dateAndTimeLocal = moment(this.mobilePickerValue,
            nativePickerFormat);
        } else {
          dateAndTimeLocal = this.dateValue;
        }

        if (this.showTime) {
          this.mobilePickerValue = dateAndTimeLocal.format(nativePickerFormat);
        } else {
          this.mobilePickerValue = dateAndTimeLocal.format(
            nativeDatePickerFormat);
        }

        this.$emit('dateObject', DateTypeCheck({
          dateMoment: dateAndTimeLocal,
          dateString:
              dateAndTimeLocal.format().substring(0, 19),
        }));
      }
    },

    // handleDatePick handle a date selection from the child date picker.
    async handleDatePick({
      event = null,
      isBlur = null,
    }) {
      const lockRelease = await this.dateSetterMutex.acquire();

      // Hacks to figure out the actual intended end date when in date mode,
      // since it's off by one.
      let offsetDate = null;
      if (this.dayModeOffset) offsetDate = this.dateValueDownstream;
      if (_.isNull(offsetDate) && this.mobileView && event) {
        offsetDate = moment(_.get(event, 'target.value', ''),
          nativeDatePickerFormat).toISOString();
      } else if (!_.isNull(offsetDate)) {
        offsetDate = offsetDate.toISOString();
      }
      if (!_.isNull(offsetDate)) {
        const dateActual = moment(offsetDate);
        if (this.dayModeOffset) dateActual.add(1, 'days');
        this.dateValue = dateActual;
      } else {
        this.dateValue = this.dateValueDownstream;
      }
      this.generateMomentDate(isBlur);
      lockRelease();
    },

    // handleTimeObj handles a time object emitted from the clock picker
    // child.
    async handleTimeObj(timeObj) {
      const lockRelease = await this.dateSetterMutex.acquire();
      this.timeValue = timeObj;
      this.generateMomentDate();
      lockRelease();
    },

    // ***********************************************************************
    // Parent accessible via $refs
    // ***********************************************************************

    // DateSet handles a moment date passed from a parent.
    async DateSet(dateArg) {
      const lockRelease = await this.dateSetterMutex.acquire();

      try {
        // Destructure if it's a known format.
        let date = dateArg;
        if (_.get(date, 'dateMoment')) {
          date = date.dateMoment;
        }

        // Timezoned moment dates must be untimezoned.
        if (!_.isNull(_.get(date, '_z', null))) {
          date = moment(date.format('YYYY-MM-DDTHH:mm:ss'));
        }
        if (!(date instanceof moment)) {
          throw Error('Unknown date object passed to DateSet', dateArg);
        }

        // If the day of this changes, ensure the dateToggle is off.
        if (date.format(this.DATE_VALUE_FORMAT) !==
          moment(this.dateValue).format(this.DATE_VALUE_FORMAT) &&
          _.isDate(this.dateValue)) {
          this.dateToggle = true;
        }

        this.dateValue = date;

        // Desktop.
        if (!this.mobileView) {
          this.dateValueDownstream = date.toDate();
          if (this.dayModeOffset && !this.mobileView) {
            this.dateValueDownstream = moment(this.dateValue).add(-1, 'days')
              .toDate();
          }

          let idDownstream = this.timePickerUniqueId;
          if (this.clockPickerUniqueId) {
            idDownstream = this.clockPickerUniqueId;
          }

          await this.dispenser.transmit(idDownstream,
            {
              name: 'hourset',
              value: date.hours(),
            });
          await this.dispenser.transmit(idDownstream,
            {
              name: 'minuteset',
              value: date.minutes(),
            });

          this.timeValue = {
            hour: date.hours(),
            minute: date.minutes(),
          };
        } else {
          // Mobile.
          this.dateValueDownstream = date.toDate();
          this.timeValue = {
            hour: date.hours(),
            minute: date.minutes(),
          };

          if (this.showTime) {
            this.mobilePickerValue = date.format(nativePickerFormat);
          } else {
            this.mobilePickerValue = date.format(nativeDatePickerFormat);
          }
        }
      } catch (err) {
        this.$emit('emitError', err);
      } finally {
        lockRelease();
      }
    },

    // FocusDatePicker focuses on either datepicker, or the mobile view
    // date picker if we are in mobile mode.
    FocusDatePicker() {
      if (!this.dayModeOffset &&
        _.get(this, `$refs.${this.datePickerRefName}`) &&
        !this.mobileView) {
        this.$refs[this.datePickerRefName].FocusOnInputElement();
      }
      if (this.dayModeOffset &&
        _.get(this, `$refs.${this.datePickerDayModeRefName}`) &&
        !this.mobileView) {
        this.$refs[this.datePickerDayModeRefName].FocusOnInputElement();
      }
      if (this.mobileView && this.showTime &&
        _.get(this, `$refs.${this.mobileInputDateTimeRefName}`)) {
        this.$refs[this.mobileInputDateTimeRefName].focus();
      }
      if (this.mobileView && !this.showTime &&
        _.get(this, `$refs.${this.mobileInputDateRefName}`)) {
        this.$refs[this.mobileInputDateRefName].focus();
      }
    },
  },

  async mounted() {
    // If a default date has been passed, set it here.
    const d = moment();

    // Set a default value.
    this.dateValue = this.defaultDate ?
      this.defaultDate.toDate() :
      d.toDate();

    // Tweak the downstream (child component passed) values to this new
    // date value.
    this.dateValueDownstream = this.dateValue;
    this.timeValue = {
      hour: !_.isUndefined(this.defaultHour) ? this.defaultHour :
        d.hours(),
      minute: !_.isUndefined(this.defaultMinute) ? this.defaultMinute :
        d.minutes(),
    };

    if (this.dayModeOffset && !this.mobileView) {
      this.dateValueDownstream = moment(this.dateValue).add(-1, 'days')
        .toDate();
    }

    // Set the value in the native datetime picker if we're mobile.
    if (this.mobileView && this.defaultDate && this.showTime) {
      this.mobilePickerValue = this.defaultDate
        .clone()
        .hour(this.timeValue.hour)
        .minute(this.timeValue.minute)
        .format(nativePickerFormat);
    } else if (this.mobileView && this.defaultDate && !this.showTime) {
      const mpvMoment = this.defaultDate
        .clone()
        .hour(this.timeValue.hour)
        .minute(this.timeValue.minute);
      if (this.dayModeOffset) {
        this.mobilePickerValue = mpvMoment.add(-1, 'days')
          .format(nativeDatePickerFormat);
      } else {
        this.mobilePickerValue = mpvMoment.format(nativeDatePickerFormat);
      }
    }

    if (this.immediate) {
      this.generateMomentDate();
    }

    this.onInit();

    if (this.focusDatePicker) this.FocusDatePicker();
  },

  props: {
    // Arrays
    defaultTimes: {
      type: Array,
      required: false,
      default: () => [],
    },

    // Booleans
    clockPicker: {
      type: Boolean,
      default: false,
    },
    dayModeOffset: { // offset one day prior for end dates in day mode
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    focusDatePicker: {
      type: Boolean,
      default: false,
    },
    // immediate triggers an emission of the datetime object on startup.
    immediate: {
      type: Boolean,
      default: false,
    },
    showDate: {
      type: Boolean,
      default: true,
    },
    showDateAsToggle: {
      type: Boolean,
      default: false,
    },
    showTime: {
      type: Boolean,
      default: true,
    },
    withColumns: {
      type: Boolean,
      default: true,
    },

    // Functions
    disabledDate: {
      type: Function,
      default: () => false,
    },
    disabledTime: {
      type: Function,
      default: () => false,
    },
    onInit: {
      type: Function,
      default: () => false,
    },

    // Numbers
    defaultHour: {
      type: Number,
    },
    defaultMinute: {
      type: Number,
    },
    minuteIntervalRestriction: {
      type: Number,
    },
    minuteIntervalRestrictionDisplay: {
      type: Number,
    },
    width: {
      // Can be string too, e.g. 'auto'.
      // type: Number,
      default: 500,
    },

    // Objects
    defaultDate: { // Moment date
      type: Object,
    },
    datePickerOptions: {
      type: Object,
      required: false,
      default: () => Object({}),
    },

    // Strings
    dateToggleString: {
      type: String,
      default: 'Set Different Day',
    },
    label: {
      type: String,
    },
    nextTimePickerFocusId: {
      type: String,
      required: false,
    },
    parentEleId: {
      type: String,
      default: 'app',
    },
    timePickerId: {
      type: String,
      required: false,
    },
    timePickerMode: {
      type: String,
      required: false,
    },
    uniqueId: {
      type: String,
      required: false,
      default: () => uuid4(),
    },
  },

  watch: {
    dayModeOffset: {
      handler: function handler(val) {
        if (val) {
          this.dateValueDownstream = moment(this.dateValue).add(-1, 'days')
            .toDate();
        } else {
          this.dateValueDownstream = moment(this.dateValue).add(1, 'days')
            .toDate();
        }
      },
    },

    // showDateAsToggle watch will immediately disable the toggle forever
    // as soon as we disable it once.  This means that once the date is
    // shown (toggle hidden) it stays shown so as not to confuse the user.
    showDateAsToggle: {
      handler: function handler(val) {
        if (!val) this.dateToggle = true;
      },
    },

    showTime: {
      handler: function handler() {
        if (this.mobileView && this.showTime) {
          this.mobilePickerValue = moment(this.dateValue)
            .clone()
            .hour(this.timeValue.hour)
            .minute(this.timeValue.minute)
            .format(nativePickerFormat);
        } else if (this.mobileView && !this.showTime) {
          const mpvMoment = moment(this.dateValue)
            .clone()
            .hour(this.timeValue.hour)
            .minute(this.timeValue.minute);
          if (this.dayModeOffset) {
            this.mobilePickerValue = mpvMoment.add(-1, 'days')
              .format(nativeDatePickerFormat);
          } else {
            this.mobilePickerValue = mpvMoment.format(nativeDatePickerFormat);
          }
        }
      },
    },
  },
};
</script>

<style lang="scss">
  @import "~assets/css/datetimepicker";

  .el-popper {
    max-width: 300px;
  }

  @media only screen and (max-width: 840px) {
    .el-popper {
      left: 0px!important;
      max-width: 100vw;
    }
  }

  @media only screen and (max-width: 840px) {
    .columns-width-resv-book-local {
      width: auto;
    }
  }

  .col-less-padding-resv-book-local {
    position: relative;
    padding: 2px;
    align-items: center;
    align-content: center;
    text-align: center;
  }

  @media only screen and (max-width: 840px) {
    .col-less-padding-resv-book-local {
      align-items: left;
      align-content: left;
      text-align: left;
    }
  }

  .date-picker-preview {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    color: #1f2d3d;
    display: block;
    height: 37px;
    line-height: 1;
    outline: 0;
    padding: 3px 10px;
    -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 100%;
    margin-bottom: 3px;
    position: relative;

    input {
      // position: absolute;
      width: 100%;
      margin: 0 auto;
      // left: 0;
      // top: 0;
      padding-left: 18px;
      background-color: transparent;
      padding-top: 6px;
      padding-bottom: 10px;
      font-size: 13.3333px;
      border: transparent !important;
      outline: none !important;
    }
  }

  .blocking-overlay {
    position: fixed;
    height: 100vh;
    width: 100vw;
    display: flex;
    top: 0;
    left: 0;
    z-index: 400;
  }

  .label-class-resv-book-local {
    display: flex;
    align-items: center; /* Vertical center alignment */
    justify-content: left; /* Horizontal center alignment */
    transform: translateY(-3%);
    font-size: 1.5rem;
  }

  .clock {
    position: absolute;
    top: 10px;
    left: 8px;
  }

  .time-picker-preview {
    input {
      left: 0px;
      top: -3px;
    }
  }

  /* VFG will inject after content for required fields. Block it here. */
  .columns-width-resv-book-local label::after {
    content: '' !important;
  }

  .datepicker-disabled {
    .date-picker-preview {
      background-color: #F4F4F4;
      margin-bottom: 5px;
    }
    input:disabled {
      background-color: #F4F4F4;
      color: #888888;
      border: none;
    }
  }

  .dark-mode {
    .date-picker-preview {
      background-color: $dmbglight;
      color: $dmtext;
      input {
        color: $dmtext;
      }
    }
    .datepicker-disabled {
      .date-picker-preview {
        background-color: $dmbglight;
        margin-bottom: 5px;
      }
      input:disabled {
        background-color: $dmbglight;
        color: $dmtextlight;
        border: none;
      }
    }
  }

</style>
